// SPDX-License-Identifier: AGPL-3.0-or-later

export enum HelpCenterArticleSlug {
	AttachmentExpiry = 'attachment-expiry',
	ChangeDateOfBirth = 'change-date-of-birth',
}
